export default __webpack_public_path__ + "static/media/backup-with-data-recovery.729221d8.jpg";